module.exports = __webpack_public_path__ + "static/media/stadium-arcadium.f62298ed.jpg";